import React from "react";
import styles from "./DocumentHeader.module.css";
import ZoomHandler from "./zoom-handler/ZoomHandler";
import PageHandler from "./page-handler/PageHandler";
import DocumentsContainer from "../../../documents-container/DocumentsContainer";
import { CustomIconButton, icon } from "../../../../../../common/components";

const DocumentHeader = ({ editor, onClose, pdfContainerWidth }) => (
	<div className={styles.container}>
		<div className={styles.container__leftSide}>
			<DocumentsContainer editor={editor} />
		</div>
		<div className={styles.container__middleSide}>
			<ZoomHandler pdfContainerWidth={pdfContainerWidth} />
			<PageHandler />
		</div>
		<div className={styles.container__rightSide}>
			<CustomIconButton icon={icon.faTimes} size="sm" onClick={onClose} />
		</div>
	</div>
);
export default DocumentHeader;
